const sizes = {
  default: 'default',
  xs: 'xs',
  sm: 'sm',
  md: 'md',
  lg: 'lg',
  xl: 'xl',
  '2xl': '2xl',
  '3xl': '3xl',
  '4xl': '4xl',
  '5xl': '5xl',
  '6xl': '6xl',
  '7xl': '7xl'
};

const colors = {
  default: 'default',
  primary: 'primary',
  light: 'light',
  grey: 'grey',
  'grey-6': 'grey-6',
  dark: 'dark',
  danger: 'danger',
  warning: 'warning',
  success: 'success',
  info: 'info',
  white: 'white',
  black: 'black',
  teal: 'teal',
  ocean: 'ocean',
  'rock-blue': 'rock-blue',
  celery: 'celery',
  nativo: 'nativo',
  transparent: 'transparent'
};

const weights = {
  hairline: 'hairline',
  thin: 'thin',
  normal: 'normal',
  medium: 'medium',
  semibold: 'semibold',
  bold: 'bold'
};

const textDecs = {
  roman: 'roman',
  underline: 'underline',
  'line-through': 'line-through',
  italic: 'italic',
  uppercase: 'uppercase',
  lowercase: 'lowercase',
  capitalize: 'capitalize'
};

const textLeading = {
  default: 'default',
  none: 'none',
  tight: 'tight',
  normal: 'normal',
  loose: 'loose'
};

const iconNames = {
  circle: 'circle',
  plusCircle: 'plusCircle',
  checkCircle: 'checkCircle',
  check: 'check',
  timesCircle: 'timesCircle',
  questionCircle: 'questionCircle',
  exclamationTriangle: 'exclamationTriangle',
  exclamationCircle: 'exclamationCircle',
  squareFull: 'squareFull',
  spinner: 'spinner',
  copy: 'copy',
  times: 'times',
  play: 'play',
  pause: 'pause',
  pencil: 'pencil',
  trash: 'trash',
  lock: 'lock',
  angleRight: 'angleRight',
  angleLeft: 'angleLeft',
  angleDown: 'angleDown',
  angleDoubleLeft: 'angleDoubleLeft',
  angleDoubleRight: 'angleDoubleRight',
  longArrowAltUp: 'longArrowAltUp',
  exchangeAlt: 'exchangeAlt',
  infoCircle: 'infoCircle',
  calendarAlt: 'calendarAlt',
  bars: 'bars',
  asterisk: 'asterisk',
  search: 'search',
  clock: 'clock',
  thumbsDown: 'thumbsDown',
  octagon: 'octagon',
  ban: 'ban',
  flask: 'flask',
  mobile: 'mobile',
  desktop: 'desktop',
  desktopAlt: 'desktopAlt',
  star: 'star',
  ellipsisH: 'ellipsisH',
  cog: 'cog',
  usdCircle: 'usdCircle',
  newspaper: 'newspaper',
  browser: 'browser',
  filter: 'filter',
  playCircle: 'playCircle',
  cloudUpload: 'cloudUpload',
  suitcase: 'suitcase',

  // Social icons don't have types light/regular/solid so just set everything
  // to be of light type since that is the default.
  // Facebook Square
  facebookSquare: 'facebookSquare',
  // Pinterest
  pinterest: 'pinterest',
  // Twitter
  twitterSquare: 'twitterSquare',
  // Telegram Plane
  telegramPlane: 'telegramPlane',
  // Stories
  stories: 'stories',
  // Sliders Vertical
  slidersV: 'slidersV',
  // eye
  eye: 'eye'
};

function generateClassObject(prefix, enums) {
  let classes = {};

  for (const key in enums) {
    classes[key] = `${prefix}-${key}`;
  }

  return classes;
}

const enums = {
  sizes,
  colors,
  weights,
  textDecs,
  textLeading,
  iconNames,
  // Generates the string value "text-{size}"
  // Ex. xs = "text-xs"
  textSizeClasses: generateClassObject('text', sizes),
  // Generates the string value "font-{weight}"
  // Ex. bold = "font-bold"
  textWeightClasses: generateClassObject('font', weights),
  // Generates the string value "leading-{leading}"
  // Ex. bold = "leading-tight"
  textleadingClasses: generateClassObject('leading', textLeading),
  // Generates the string value "text-{color}"
  // Ex. primary = "text-primary"
  textColorClasses: generateClassObject('text', colors),
  // Generates the string value "bg-{color}"
  // Ex. primary = "bg-primary"
  bgColorClasses: generateClassObject('bg', colors),
  // Class names for text decorations are the same as their names
  textDecClasses: textDecs
};

export default enums;
